var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "text-align",
      rawName: "v-text-align.center",
      modifiers: {
        "center": true
      }
    }]
  }, [_c('v-spinner')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b770fe7","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/sign/ForceLogin.vue
// module id = 866
// module chunks = 0